import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { getUserConversions } from '../utils/supabaseHelpers';
import { SUPPORTED_FORMATS } from '../utils/imageConverter';

const { FiClock, FiArrowRight } = FiIcons;

const ConversionHistory = ({ user }) => {
  const [conversions, setConversions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchConversions = async () => {
      if (!user) {
        setLoading(false);
        return;
      }

      try {
        const data = await getUserConversions(user.id);
        setConversions(data);
      } catch (error) {
        console.error('Fehler beim Laden der Konvertierungen:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchConversions();
  }, [user]);

  if (!user) {
    return (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="text-center text-gray-500 py-8"
      >
        <p>Melde dich an, um deine Konvertierungshistorie zu sehen</p>
      </motion.div>
    );
  }

  if (loading) {
    return (
      <div className="flex justify-center py-8">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="space-y-4"
    >
      <h3 className="text-lg font-medium text-primary-600 flex items-center space-x-2">
        <SafeIcon icon={FiClock} />
        <span>Letzte Konvertierungen</span>
      </h3>

      {conversions.length === 0 ? (
        <p className="text-gray-500 text-center py-4">Noch keine Konvertierungen</p>
      ) : (
        <div className="space-y-2">
          {conversions.map((conversion, index) => (
            <motion.div
              key={index}
              initial={{ x: -20, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ delay: index * 0.1 }}
              className="flex items-center justify-between p-3 bg-gray-50 rounded-lg"
            >
              <div className="flex items-center space-x-3">
                <span className="text-sm font-medium text-primary-600">
                  {SUPPORTED_FORMATS[conversion.source_format]?.label || 'Unbekannt'}
                </span>
                <SafeIcon icon={FiArrowRight} className="text-gray-400" />
                <span className="text-sm font-medium text-primary-600">
                  {SUPPORTED_FORMATS[conversion.target_format]?.label || 'Unbekannt'}
                </span>
              </div>
              <span className="text-xs text-gray-500">
                {new Date(conversion.timestamp).toLocaleDateString('de-DE')}
              </span>
            </motion.div>
          ))}
        </div>
      )}
    </motion.div>
  );
};

export default ConversionHistory;